import React, { useState, useEffect } from 'react';
import { Badge } from './Badge';
import { apiFetch } from '../../utils/api';

export const RagStatusBadge = ({ documentId }) => {
    const [statusData, setStatusData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let isMounted = true;
        const fetchStatus = async () => {
            try {
                const res = await apiFetch(`/api/admin/rag/ingest-status?document_id=${documentId}`);
                if (res.ok) {
                    const data = await res.json();
                    if (isMounted) setStatusData(data);
                }
            } catch (e) {
                // silent fail
            } finally {
                if (isMounted) setLoading(false);
            }
        };
        fetchStatus();
        return () => { isMounted = false; };
    }, [documentId]);

    if (loading) {
        return <div className="w-16 h-5 bg-stone-800 rounded animate-pulse" />;
    }

    if (!statusData || statusData.status === 'NOT_STARTED' || statusData.status === 'PENDING') {
        return <Badge color="gray" size="sm">Pending</Badge>;
    }

    const { status, last_error, last_run_at, attempt_count } = statusData;

    const colorMap = {
        'RUNNING': 'blue',
        'COMPLETED': 'green',
        'FAILED': 'red'
    };

    const labelMap = {
        'RUNNING': 'Running',
        'COMPLETED': 'Indexed',
        'FAILED': 'Failed'
    };

    // Tooltip content
    let title = "";
    if (last_run_at) title += `Last Run: ${new Date(last_run_at).toLocaleString()}\n`;
    if (attempt_count > 0) title += `Attempts: ${attempt_count}\n`;
    if (last_error) title += `Error: ${last_error}`;

    return (
        <div title={title} className="cursor-help">
            <Badge color={colorMap[status] || 'gray'} size="sm">
                {labelMap[status] || status}
            </Badge>
        </div>
    );
};
